export const convertBytesToSize = (bytes: number): string => {
  if (!bytes || bytes === 0) return "0 Bytes";

  const sizes: string[] = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
  const i: number = Math.floor(Math.log(bytes) / Math.log(1024));

  // Ensure i is within bounds of the sizes array
  if (i >= sizes.length) return "Size too large";

  // No need for parseInt since Math.floor already returns a number
  return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
};

export default convertBytesToSize;
